var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.031,
    height: 162.156,
    viewBox: "0 0 227.031 162.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill",
    fill: "#ffffff",
    transform: "translate(-43.231 -252.324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H160.362L172.6,22H0Z",
    transform: "translate(43.914 402.797) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H160.362L172.6,22H0Z",
    transform: "translate(104.254 402.783) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H160.362L172.6,22H0Z",
    transform: "translate(164.188 402.797) rotate(-60)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmenuActive);
export default __webpack_public_path__ + "static/media/submenu_active.78c53fa59f8824d9f62e485aeb13d937.svg";
export { ForwardRef as ReactComponent };